import userManager from './oidc'
import type { User } from 'oidc-client-ts'

/* Demande au Service Worker de rejouer la queue des CR en attente */
export function requestQueueReplay() {
  navigator.serviceWorker?.controller?.postMessage({ type: 'REPLAY_QUEUE' })
}

let replayTriggersRegistered = false

/*
 * Ne dépend pas de l'API Background Sync : rejoue la queue au retour du réseau,
 * au retour au premier plan de l'app, et une fois au démarrage.
 */
export function registerQueueReplayTriggers() {
  if (replayTriggersRegistered) {
    return
  }
  replayTriggersRegistered = true
  window.addEventListener('online', requestQueueReplay)
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible' && navigator.onLine) {
      requestQueueReplay()
    }
  })
  if (navigator.onLine) {
    requestQueueReplay()
  }
}

/* Envoie au Service Worker les informations d'authentification */
export async function syncAuthWithServiceWorker(user?: User) {
  if (!navigator.serviceWorker?.controller) {
    return
  }

  try {
    if (!user) {
      user = (await userManager.getUser()) ?? undefined
    }

    if (user?.access_token) {
      // Envoyer le token et les infos utilisateur au service worker
      navigator.serviceWorker.controller.postMessage({
        type: 'SET_AUTH',
        payload: {
          accessToken: user.access_token,
          tokenType: user.token_type || 'Bearer',
          expiresAt: user.expires_at,
          profile: {
            name: user.profile?.name,
            email: user.profile?.email,
            id: user.profile?.sub,
          },
        },
      })
    }
  } catch (error) {
    console.error("Erreur lors de la synchronisation de l'authentification", error)
  }
}
